import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { PaginationContainer } from './style'

interface ITablePaginationProps {
  pageCount: number
  initialPage?: number
  onPageChange?: (page: number) => void
}

const TablePagination: React.FC<ITablePaginationProps> = ({
  pageCount,
  initialPage = 0,
  onPageChange
}) => {
  const [page, setPage] = useState(initialPage)

  useEffect(() => {
    setPage(initialPage)
  }, [initialPage])

  const handlePageChange = ({ selected }: { selected: number }) => {
    setPage(selected)
    if (onPageChange) {
      onPageChange(selected)
    }
  }

  if (pageCount <= 0) return null

  return (
    <PaginationContainer>
      <ReactPaginate
        nextLabel=">"
        onPageChange={handlePageChange}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel="<"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
        forcePage={page}
      />
    </PaginationContainer>
  )
}

export default TablePagination

